import { AUTH } from '@constants/actions';
import createAction from './actionCreator';

export const authValidateUser = (valid) => {
  return createAction(AUTH.VALIDATION.RESULT, { valid });
};